module.exports = __webpack_public_path__ + "static/jonathan-agoot-machine-learning-algorithm-development-overview-fee9a0ffde0100bd63b29f25a2172766.jpg";